import { render, staticRenderFns } from "./MaritalStatusField.vue?vue&type=template&id=76c69500&scoped=true"
import script from "./MaritalStatusField.vue?vue&type=script&lang=js"
export * from "./MaritalStatusField.vue?vue&type=script&lang=js"
import style0 from "./MaritalStatusField.vue?vue&type=style&index=0&id=76c69500&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c69500",
  null
  
)

export default component.exports